import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { HttpClientService } from "../shared/services/httpclient";

import { environment } from "../../environments/environment";
import { ApplicationScreen } from "./models/application-screen.interface";
import { select } from "@angular-redux/store";
import { env } from "process";
import { ApplicationUser } from "../pb-screen/models/application.user.interface";
import { UserActions, UserAuthorization } from "./models/user-authorization.interface";
import { IdNameAsStringObject } from "../pb-screen/models/quick-view/id-name-as-string-object.interface";

@Injectable()
export class UsersAuthorizationService {
    
    @select("applicationUser") public applicationUser$: Observable<any>;
    applicationUser: ApplicationUser;

    public screens: string[] = [];
    constructor(
        private http: HttpClientService) { 

         this.fillAvailableApplicationScreens();

          this.applicationUser$.subscribe((data) => {
               if (data) {
                this.applicationUser = data;
                if(environment.enableAuthorizationModule) {
                 this.screens = data.userAuthorization.screenAuthorizations.filter(a => a.authorized).map(a => a.screenName);
                }
                 
               } }) ; 
       }

     
    public getAllUsers()
    {
        return this.http.get(environment.tmsApiEndpointAddress + "users").pipe(
            map((res : any) => { return res.data }), catchError((err) => { return Observable.throw(err)})
        )
    }

    public getUser(id)
    {
        return this.http.get(environment.tmsApiEndpointAddress + "users/" + id).pipe(
            map((res : any) => { return res.data }), catchError((err) => { return Observable.throw(err)})
        )
    }

    canAccessScreen(screenName: string): boolean {   
        if(environment.enableAuthorizationModule == false) {
            return true;
        }

        
        if(screenName == "multi-day-compact")
            screenName = "week-planning" ; 

        return this.screens.includes(screenName);
    }

    fillAvailableApplicationScreens() {

        ApplicationScreens.push({ screenName: "planning", screenCaption: "Planning Board" });

        ApplicationScreens.push({ screenName: "week-planning", screenCaption: "Multi-Days Planning" });
        ApplicationScreens.push({ screenName: "pb-screen", screenCaption: "Planning Blocks" });
        ApplicationScreens.push({ screenName: "to-screen", screenCaption: "Transport Orders" });
        if (environment.depotInIcon)
            ApplicationScreens.push({ screenName: "depot-in", screenCaption: "Depot In" });
        if (environment.depotOutIcon)
            ApplicationScreens.push({ screenName: "depot-out", screenCaption: "Depot Out" });

        ApplicationScreens.push({ screenName: "driveragenda", screenCaption: "Driver Agenda" });
        ApplicationScreens.push({ screenName: "truckagenda", screenCaption: "Truck Agenda" });
        if (environment.stackerIcon)
            ApplicationScreens.push({ screenName: "stacker", screenCaption: "Stacker" });
        if (environment.containerPoolEnabled)
            ApplicationScreens.push({ screenName: "pool", screenCaption: "Pool" });
        if (environment.containerPoolEnabled)
            ApplicationScreens.push({ screenName: "announcement", screenCaption: "Announcement" });

        if (environment.showWaitingRoom)
            ApplicationScreens.push({ screenName: "waiting-room", screenCaption: "Waiting Room" });


    }

    public getAuthorizedPlanningGroupForPBScreen(applicationUser: ApplicationUser) : string {
        if(environment.enableAuthorizationModule == false) {
            return applicationUser.defaultPlanGroupsForPlanningBlockScreen?.join(",") ?? environment.defaultPlanningGroup;
        }
        else { 
            if (applicationUser.userAuthorization.planningGroupAuthorizations.length == 0) {
                return null; 
            }

            return applicationUser.userAuthorization.planningGroupAuthorizations.join(",") ?? applicationUser.planningGroups?.join(",") ?? environment.defaultPlanningGroup;
        }
    }

    static filterPlanningGroupsAsIdName(userAuthorization: UserAuthorization, planningGroups: IdNameAsStringObject[]): IdNameAsStringObject[] {
        if(environment.enableAuthorizationModule == false) {
            return planningGroups;
        }
        else { 
            return planningGroups.filter(pg => userAuthorization.planningGroupAuthorizations.includes(pg.id));
        }
    }

    static filterPlanningGroupsAsStrings(defaultPlanGroups: string[], userAuthorization: UserAuthorization): string[] {
        if (environment.enableAuthorizationModule == false) {
            return defaultPlanGroups;
        }
        else { 
            return defaultPlanGroups.filter(pg => userAuthorization.planningGroupAuthorizations.includes(pg));
        }

    }


    canAddPBToExistingTO() :boolean { 
        return !environment.enableAuthorizationModule ||  this.applicationUser.userAuthorization.actionAuthorizations.filter( x=> x.actionName== UserActions.canAddPBToExistingTO && x.authorized).length > 0; 
    }

    static isPlanningGroupAuthorized(applicationUser: ApplicationUser, planningGroup: any) {
        if(environment.enableAuthorizationModule == false) {
            return true;
        }
        else 
        { 
            return applicationUser.userAuthorization.planningGroupAuthorizations.includes(planningGroup) || applicationUser.userAuthorization.planningGroupAuthorizations.includes("All");
        }
    }

    getAuthorizedPlanningGroupForDepots() : string[] {
        if (environment.enableAuthorizationModule == false) {
            return ['ALL'] ; 
        }
        else {
            if (this.applicationUser.userAuthorization.planningGroupAuthorizations.length == 0) {
                return null;
            }
            return this.applicationUser.userAuthorization.planningGroupAuthorizations;
        }
    }

    getAuthorizedPlanningGroups(applicationUser: ApplicationUser): string[] {
        if (environment.enableAuthorizationModule == false) {
            return ["ALL"];
        }
        else {
            return applicationUser.userAuthorization.planningGroupAuthorizations;
        }
    }

}
export const ApplicationScreens: ApplicationScreen[]= [];